var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "interest" }, [
    _c("div", { staticClass: "clearfix" }),
    _vm.beError
      ? _c(
          "div",
          { staticClass: "row" },
          [
            _vm.errorsText.length == 0
              ? _c("h3", [_vm._v("Hoops valamilyen hiba történt...")])
              : _c("h3", { staticClass: "mb-3" }, [_vm._v("Hiba történt:")]),
            _vm._v(" "),
            _c("br"),
            _vm._l(_vm.errorsText, function (error) {
              return _c("p", [
                error.hibas == 1
                  ? _c("span", {
                      domProps: { innerHTML: _vm._s(error.hiba_szoveg) },
                    })
                  : _vm._e(),
              ])
            }),
          ],
          2
        )
      : _vm._e(),
    !_vm.isSubmitFormSend
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("stepper", {
                attrs: {
                  steps: _vm.steps,
                  currentStep: _vm.currentStep,
                  maxStep: _vm.maxCurrentStep,
                },
                on: { selectedStep: _vm.onSelectStep },
              }),
              _vm.currentStep == 0
                ? _c("div", { staticClass: "step " }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(0),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-sm-12 col-lg-12" },
                          [
                            _c("div", { staticClass: "form-check-wrapper" }, [
                              _c("label", { staticClass: "form-check-label" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.step0.mikor_tervezi_a_hoszigetelest,
                                      expression:
                                        "step0.mikor_tervezi_a_hoszigetelest",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "radio",
                                    value: "1",
                                    name: "mikor_tervezi_a_hoszigetelest",
                                    checked: "",
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.step0.mikor_tervezi_a_hoszigetelest,
                                      "1"
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$set(
                                        _vm.step0,
                                        "mikor_tervezi_a_hoszigetelest",
                                        "1"
                                      )
                                    },
                                  },
                                }),
                                _c("span", {
                                  staticClass: "mdi mdi-name check-span",
                                }),
                                _c("span", { staticClass: "checkbox-text" }, [
                                  _vm._v("1-3 hónapon belül"),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-sm-12 col-lg-12" },
                          [
                            _c("div", { staticClass: "form-check-wrapper" }, [
                              _c("label", { staticClass: "form-check-label" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.step0.mikor_tervezi_a_hoszigetelest,
                                      expression:
                                        "step0.mikor_tervezi_a_hoszigetelest",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "radio",
                                    value: "2",
                                    name: "mikor_tervezi_a_hoszigetelest",
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.step0.mikor_tervezi_a_hoszigetelest,
                                      "2"
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$set(
                                        _vm.step0,
                                        "mikor_tervezi_a_hoszigetelest",
                                        "2"
                                      )
                                    },
                                  },
                                }),
                                _c("span", {
                                  staticClass: "mdi mdi-name check-span",
                                }),
                                _c("span", { staticClass: "checkbox-text" }, [
                                  _vm._v("3 hónapon túl"),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "row mt-2" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button button-sm type-3",
                              on: {
                                click: function ($event) {
                                  return _vm.backUrl()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon mdi mdi-arrow-left",
                              }),
                              _vm._v("Vissza"),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "col-6" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button button-sm float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.nextStep()
                                },
                              },
                            },
                            [_vm._v("Tovább")]
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm.currentStep == 1
            ? _c("div", { staticClass: "step" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(1),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-sm-6 col-lg-6 mb-4" },
                        [
                          _c("simple-dropdown", {
                            attrs: {
                              dataSource: _vm.epuletJellege,
                              displayProp: "title",
                              placeholder: "Jellege*",
                              errorClass: _vm.$v.step1.epulet_jellege.$error,
                            },
                            model: {
                              value: _vm.step1.epulet_jellege,
                              callback: function ($$v) {
                                _vm.$set(_vm.step1, "epulet_jellege", $$v)
                              },
                              expression: "step1.epulet_jellege",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-12 col-sm-6 col-lg-6 mb-3" },
                        [
                          _c("simple-dropdown", {
                            attrs: {
                              dataSource: _vm.epuletAllapota,
                              displayProp: "title",
                              placeholder: "Állapota*",
                              errorClass: _vm.$v.step1.epulet_allapota.$error,
                            },
                            model: {
                              value: _vm.step1.epulet_allapota,
                              callback: function ($$v) {
                                _vm.$set(_vm.step1, "epulet_allapota", $$v)
                              },
                              expression: "step1.epulet_allapota",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.step1.iranyitoszam,
                              expression: "step1.iranyitoszam",
                            },
                          ],
                          class: {
                            "form-control": true,
                            "form-input-item": true,
                            "invalid-error": _vm.$v.step1.iranyitoszam.$error,
                          },
                          attrs: {
                            name: "iranyitoszam",
                            type: "text",
                            placeholder: "Irányítószám*",
                          },
                          domProps: { value: _vm.step1.iranyitoszam },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.step1,
                                "iranyitoszam",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.step1.telepules,
                              expression: "step1.telepules",
                            },
                          ],
                          class: {
                            "form-control": true,
                            "form-input-item": true,
                            "invalid-error": _vm.$v.step1.telepules.$error,
                          },
                          attrs: {
                            name: "telepules",
                            type: "text",
                            placeholder: "Település*",
                          },
                          domProps: { value: _vm.step1.telepules },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.step1,
                                "telepules",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.step1.cim,
                              expression: "step1.cim",
                            },
                          ],
                          class: {
                            "form-control": true,
                            "form-input-item": true,
                            "invalid-error": _vm.$v.step1.cim.$error,
                          },
                          attrs: {
                            name: "cim",
                            type: "text",
                            placeholder: "Közterület neve és típusa*",
                          },
                          domProps: { value: _vm.step1.cim },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.step1, "cim", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.step1.hazszam,
                              expression: "step1.hazszam",
                            },
                          ],
                          class: {
                            "form-control": true,
                            "form-input-item": true,
                            "invalid-error": _vm.$v.step1.hazszam.$error,
                          },
                          attrs: {
                            name: "hazszam",
                            type: "text",
                            placeholder: "Házszám*",
                          },
                          domProps: { value: _vm.step1.hazszam },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.step1,
                                "hazszam",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.step1.hoszigeteles_leirasa,
                              expression: "step1.hoszigeteles_leirasa",
                            },
                          ],
                          class: {
                            "form-control": true,
                            "form-input-item": true,
                            "invalid-error":
                              _vm.$v.step1.hoszigeteles_leirasa.$error,
                          },
                          attrs: {
                            name: "hoszigeteles_leirasa",
                            placeholder:
                              "Kérjük, a hőszigeteléssel kapcsolatosan minél több pontos információt adjon itt meg (Baumit termékek, felület nagysága.) ",
                          },
                          domProps: { value: _vm.step1.hoszigeteles_leirasa },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.step1,
                                "hoszigeteles_leirasa",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button button-sm type-3",
                            on: {
                              click: function ($event) {
                                return _vm.backStep()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "icon mdi mdi-arrow-left" }),
                            _vm._v("Vissza"),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button button-sm float-right",
                            on: {
                              click: function ($event) {
                                return _vm.nextStep()
                              },
                            },
                          },
                          [_vm._v("Tovább")]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.currentStep == 2
            ? _c("div", { staticClass: "step" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(2),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.step2.name,
                              expression: "step2.name",
                            },
                          ],
                          class: {
                            "form-control": true,
                            "form-input-item": true,
                            "invalid-error": _vm.$v.step2.name.$error,
                          },
                          attrs: {
                            name: "name",
                            type: "text",
                            placeholder: "Név*",
                          },
                          domProps: { value: _vm.step2.name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.step2, "name", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.step2.phone,
                              expression: "step2.phone",
                            },
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: ["+## ## ### ####", "+## ## ### ###"],
                              expression:
                                "[ '+## ## ### ####', '+## ## ### ###']",
                            },
                          ],
                          class: {
                            "form-control": true,
                            "form-input-item": true,
                            "invalid-error": _vm.$v.step2.phone.$error,
                          },
                          attrs: {
                            name: "phone",
                            type: "text",
                            placeholder: "Mobil*",
                          },
                          domProps: { value: _vm.step2.phone },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.step2, "phone", $event.target.value)
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.step2.email,
                              expression: "step2.email",
                            },
                          ],
                          class: {
                            "form-control": true,
                            "form-input-item": true,
                            "invalid-error": _vm.$v.step2.email.$error,
                          },
                          attrs: {
                            name: "email",
                            type: "text",
                            placeholder: "E-mail cím*",
                          },
                          domProps: { value: _vm.step2.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.step2, "email", $event.target.value)
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._m(3),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-sm-6 col-lg-6 mb-4" },
                        [
                          _c("simple-dropdown", {
                            attrs: {
                              dataSource: _vm.regisztraloStatusza,
                              displayProp: "title",
                              placeholder: "Válasszon",
                              errorClass:
                                _vm.$v.step2.regisztralo_statusza.$error,
                            },
                            model: {
                              value: _vm.step2.regisztralo_statusza,
                              callback: function ($$v) {
                                _vm.$set(_vm.step2, "regisztralo_statusza", $$v)
                              },
                              expression: "step2.regisztralo_statusza",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                        _vm.step2.regisztralo_statusza &&
                        _vm.step2.regisztralo_statusza.id === 4
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.step2.regisztralo_statusza_egyeb,
                                  expression:
                                    "step2.regisztralo_statusza_egyeb",
                                },
                              ],
                              class: {
                                "form-control": true,
                                "form-input-item": true,
                                "invalid-error":
                                  _vm.$v.step2.regisztralo_statusza_egyeb
                                    .$error,
                              },
                              attrs: {
                                name: "regisztralo_statusza_egyeb",
                                type: "text",
                                placeholder: "Egyéb",
                              },
                              domProps: {
                                value: _vm.step2.regisztralo_statusza_egyeb,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.step2,
                                    "regisztralo_statusza_egyeb",
                                    $event.target.value
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                    ]),
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button button-sm type-3",
                            on: {
                              click: function ($event) {
                                return _vm.backStep()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "icon mdi mdi-arrow-left" }),
                            _vm._v("Vissza"),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button button-sm float-right",
                            on: {
                              click: function ($event) {
                                return _vm.nextStep()
                              },
                            },
                          },
                          [_vm._v("Tovább")]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentStep == 3,
                  expression: "currentStep == 3",
                },
              ],
              staticClass: "step",
            },
            [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _vm._m(4),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-6 col-lg-6 mb-4" },
                      [
                        _c("simple-dropdown", {
                          attrs: {
                            dataSource: _vm.szaktanacsadoJelentkezhetTipus,
                            displayProp: "title",
                            placeholder: "Válasszon*",
                            errorClass:
                              _vm.$v.step3.szaktanacsado_jelentkezhet_tipus
                                .$error,
                          },
                          model: {
                            value: _vm.step3.szaktanacsado_jelentkezhet_tipus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.step3,
                                "szaktanacsado_jelentkezhet_tipus",
                                $$v
                              )
                            },
                            expression:
                              "step3.szaktanacsado_jelentkezhet_tipus",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.step3.szaktanacsado_jelentkezhet_pontositas,
                            expression:
                              "step3.szaktanacsado_jelentkezhet_pontositas",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error":
                            _vm.$v.step3.szaktanacsado_jelentkezhet_pontositas
                              .$error,
                        },
                        attrs: {
                          name: "szaktanacsado_jelentkezhet_pontositas",
                          type: "text",
                          placeholder: "Pontosítás",
                        },
                        domProps: {
                          value:
                            _vm.step3.szaktanacsado_jelentkezhet_pontositas,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step3,
                              "szaktanacsado_jelentkezhet_pontositas",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
                      _c("div", { staticClass: "form-check-wrapper" }, [
                        _c("label", { staticClass: "form-check-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.step3.accept2,
                                expression: "step3.accept2",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "checkbox",
                              value: "1",
                              name: "accept2",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.step3.accept2)
                                ? _vm._i(_vm.step3.accept2, "1") > -1
                                : _vm.step3.accept2,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.step3.accept2,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "1",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.step3,
                                        "accept2",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.step3,
                                        "accept2",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.step3, "accept2", $$c)
                                }
                              },
                            },
                          }),
                          _c("span", {
                            class: {
                              "mdi mdi-name check-span": true,
                              "invalid-error": _vm.$v.step3.accept2.$error,
                            },
                          }),
                          _vm._m(5),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "only-mobile-content mb-3" }),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
                      _c("div", { staticClass: "form-check-wrapper" }, [
                        _c("label", { staticClass: "form-check-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.step3.accept4,
                                expression: "step3.accept4",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "checkbox",
                              value: "1",
                              name: "accept4",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.step3.accept4)
                                ? _vm._i(_vm.step3.accept4, "1") > -1
                                : _vm.step3.accept4,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.step3.accept4,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "1",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.step3,
                                        "accept4",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.step3,
                                        "accept4",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.step3, "accept4", $$c)
                                }
                              },
                            },
                          }),
                          _c("span", {
                            class: {
                              "mdi mdi-name check-span": true,
                              "invalid-error": _vm.$v.step3.accept4.$error,
                            },
                          }),
                          _c("span", { staticClass: "checkbox-text" }, [
                            _vm._v(
                              "Hozzájárulok, hogy részemre a Baumit Kft. újdonságairól, promócióiról, ajánlatairól e-mailt küldjön."
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "only-mobile-content mb-5" }),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button button-sm type-3",
                          on: {
                            click: function ($event) {
                              return _vm.backStep()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "icon mdi mdi-arrow-left" }),
                          _vm._v("Vissza"),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button button-sm float-right",
                          attrs: { disabled: _vm.disabledNextButton },
                          on: {
                            click: function ($event) {
                              return _vm.nextStep()
                            },
                          },
                        },
                        [_vm._v("Tovább")]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ])
      : _vm._e(),
    _vm.isSubmitFormSend
      ? _c("div", { staticClass: "row" }, [_vm._m(6)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
        _c("p", [
          _vm._v("Mikor tervezi a hőszigetelést?"),
          _c("br"),
          _vm._v(
            " Kérje munkatársunk díjmentes tanácsadását a Baumit hőszigetelő rendszer vásárlásával kapcsolatban. "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
        _c("p", [_vm._v("Érintett épület adatai")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
        _c("p", [_vm._v("Az Ön elérhetősége")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
        _c("p", [_vm._v("Az Ön státusza")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
        _c("p", [_vm._v("Mikor jelentkezhet Önnél szaktanácsadónk")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-text" }, [
      _vm._v("Megértettem és elolvastam az "),
      _c(
        "a",
        {
          staticClass: "simple-link",
          attrs: {
            target: "_blank",
            href: "https://baumit.hu/vallalat/adatkezelesi-tajekoztatok",
          },
        },
        [_vm._v("Adatkezelési tájékoztatót")]
      ),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _vm._v(
          " Köszönjük, hogy szakértőinket választotta, munkatársaink hamarosan keresni fogják a megadott elérhetőségen. "
        ),
      ]),
      _c("p", [
        _vm._v("Ha addig szívesen olvasna többet a Baumit megoldásairól, "),
        _c("a", { attrs: { href: "https://baumit.hu", target: "_blank" } }, [
          _vm._v("kattintson ide"),
        ]),
        _vm._v("."),
      ]),
      _c("p", [_vm._v("Üdvözlettel,"), _c("br"), _vm._v(" Baumit")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }